export const TOAST_ID = {
	UPDATE_GROUP_SUCCESS: 'UPDATE_GROUP_SUCCESS',
	CREATE_GROUP_SUCCESS: 'CREATE_GROUP_SUCCESS',
	APPROVE_GROUP_SUCCESS: 'APPROVE_GROUP_SUCCESS',
	DELETE_GROUP_SUCCESS: 'DELETE_GROUP_SUCCESS',
	UPDATE_SETTING_SUCCESS: 'UPDATE_SETTING_SUCCESS',
	CREATE_DEVICE_SUCCESS: 'CREATE_DEVICE_SUCCESS',
	UPDATE_DEVICE_SUCCESS: 'UPDATE_DEVICE_SUCCESS',
	DELETE_DEVICE_SUCCESS: 'DELETE_DEVICE_SUCCESS',
	UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
	CREATE_USER_SUCCESS: 'CREATE_USER_SUCCESS',
	CREATE_FLEET_SUCCESS: 'CREATE_FLEET_SUCCESS',
	UPDATE_FLEET_SUCCESS: 'UPDATE_FLEET_SUCCESS',
	DELETE_FLEET_SUCCESS: 'DELETE_FLEET_SUCCESS',
	DELETE_SECURITY_KEY_SUCCESS: 'DELETE_SECURITY_KEY_SUCCESS',
	UPDATE_SECURITY_KEY_SUCCESS: 'UPDATE_SECURITY_KEY_SUCCESS',
	CREATE_SECURITY_KEY_SUCCESS: 'CREATE_SECURITY_KEY_SUCCESS',
	DELETE_OTAP_AGENTS_SUCCESS: 'DELETE_OTAP_AGENTS_SUCCESS',
	UPDATE_OTAP_AGENT_SUCCESS: 'UPDATE_OTAP_AGENT_SUCCESS',
	IMPORT_EF_LICENSE_SUCCESS: 'IMPORT_EF_LICENSE_SUCCESS',
	DELETE_EF_LICENSE_SUCCESS: 'DELETE_EF_LICENSE_SUCCESS',
	IMPORT_FIRMWARE_SUCCESS: 'IMPORT_FIRMWARE_SUCCESS',
	UPDATE_FIRMWARE_SUCCESS: 'UPDATE_FIRMWARE_SUCCESS',
  DELETE_FIRMWARE_SUCCESS: 'DELETE_FIRMWARE_SUCCESS',
  COMMIT_DEVICE_SUCCESS: 'COMMIT_DEVICE_SUCCESS',
  CREATE_INFRASTRUCTURE_GROUP_SUCCESS: 'CREATE_INFRASTRUCTURE_GROUP_SUCCESS',
  UPDATE_INFRASTRUCTURE_GROUP_SUCCESS: 'UPDATE_INFRASTRUCTURE_GROUP_SUCCESS',
  CREATE_INFRASTRUCTURE_HARDWARE_SUCCESS: 'CREATE_INFRASTRUCTURE_HARDWARE_SUCCESS',
  UPDATE_INFRASTRUCTURE_HARDWARE_SUCCESS: 'UPDATE_INFRASTRUCTURE_HARDWARE_SUCCESS',
  UPDATE_INFRASTRUCTURE_GROUP_CONFIGURATION_SUCCESS: 'UPDATE_INFRASTRUCTURE_GROUP_CONFIGURATION_SUCCESS',
  CREATE_INFRASTRUCTURE_CERTIFICATE_SUCCESS: 'CREATE_INFRASTRUCTURE_CERTIFICATE_SUCCESS',
  UPDATE_INFRASTRUCTURE_CERTIFICATE_SUCCESS: 'UPDATE_INFRASTRUCTURE_CERTIFICATE_SUCCESS',
  DELETE_SUCCESS: 'DELETE_SUCCESS',
  CREATE_INFRASTRUCTURE_DEPLOYJOB_DEPLOYCONFIGURATION_SUCCESS: 'CREATE_INFRASTRUCTURE_DEPLOYJOB_DEPLOYCONFIGURATION_SUCCESS',
  ENTITY_NOT_FOUND: 'ENTITY_NOT_FOUND',
  HTTP_ERROR: 'HTTP_ERROR',
  UNKNOWN_ERROR: 'UNKNOWN_ERROR',
}
